/**
 * Golf FS DRIVER Reducers
 */
import {
    FSDRIVER_ACTION,
    ALL_FSDRIVER,
    ADD_FSDRIVER,
    FETCH_FSDRIVER,
    EDIT_FSDRIVER,
    DELETE_FSDRIVER
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    fsdriverlist:[],
    particularfsdriver:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case FSDRIVER_ACTION:
            return { ...state, loading: true };       

        case ALL_FSDRIVER:
            return { ...state, loading: false, fsdriverlist: action.payload };     
            
        case ADD_FSDRIVER:
            return { ...state, loading: false };     
         
        case FETCH_FSDRIVER:
            return { ...state, loading: false, particularfsdriver: action.payload };  
            
        case EDIT_FSDRIVER:
            return { ...state, loading: false }; 
            
        case DELETE_FSDRIVER:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }